"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InContentAdPlugin = void 0;
const tempest_common_1 = require("tempest-common");
const base_1 = require("../base");
class InContentAdPlugin extends base_1.BasePlugin {
    constructor() {
        super(...arguments);
        this.slotIndexMap = {};
    }
    generateMarkup(_config, contextConfig) {
        const { breakpoint } = contextConfig;
        const index = this.slotIndexMap[breakpoint] || 0;
        const zone = 'in_content';
        const slotId = (0, tempest_common_1.makeSlotId)(zone);
        this.slotIndexMap[breakpoint] = index + 1;
        return this.generateSlotMarkup({
            slotName: 'ad',
            slotConfig: {
                breakpoint,
                index,
                zone,
            },
            id: slotId,
        });
    }
}
exports.InContentAdPlugin = InContentAdPlugin;
//# sourceMappingURL=index.js.map